import { TFunction } from 'i18next';

import { ClientConfiguration, Permission } from '@Models';
import { SidebarIcons } from '../icons';
import { MenuItem } from '../types';
import { buildDocumentationItems, buildTrainingVideosItem } from './documentation';

/**
 * Logyca flavor menu. Admin (Users) → Toolkit (docs + videos).
 *
 * The Configuration / Masters entry is intentionally hidden — Logyca doesn't
 * have a real Masters surface yet, so we'd only be exposing a "Coming soon"
 * placeholder. The route in app.tsx stays mounted so any deep link still
 * resolves to the WorkInProgress page, but it's no longer reachable from the
 * sidebar. The Insights/Eventos external link is hidden for the same kind of
 * reason: the resources hub isn't relevant to the logyca audience right now.
 * Restore both entries by re-adding their blocks to the return below.
 */
const buildLogycaMenu = (configuration: ClientConfiguration | undefined, t: TFunction): MenuItem[] => [
  {
    key: 'admin',
    label: 'Admin',
    icon: SidebarIcons.admin,
    submenu: [
      {
        key: 'users',
        permission: Permission.ManageUsers,
        label: t('Sidebar.Users'),
        icon: SidebarIcons.users,
        link: '/users',
        hideWhenDisabled: true,
        enabled: true,
      },
      {
        key: 'suppliers',
        permission: [Permission.ManageSuppliers, Permission.ViewSuppliers],
        label: t('Sidebar.Suppliers'),
        icon: SidebarIcons.suppliers,
        link: '/suppliers',
        hideWhenDisabled: true,
      },
    ],
  },
  {
    key: 'toolkit',
    label: t('Sidebar.Toolkit'),
    icon: SidebarIcons.toolkit,
    submenu: [
      ...buildDocumentationItems(configuration?.dataRepository, t),
      ...buildTrainingVideosItem(configuration?.resources, t),
    ],
  },
];

export default buildLogycaMenu;
